import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HailIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hail"}/>
}
